import { formatCountdown } from "../session/rest-timer";
import { formatInt } from "./number";
/**
 * A session length: under an hour "48 min", otherwise "1 h 05" (and "2 h"
 * on the hour). The unit symbols are SI, the same in both locales; only the
 * digits go through the locale.
 */
export function formatDurationMinutes(min, locale) {
    const total = Math.max(0, Math.round(min));
    if (total < 60) {
        return `${formatInt(total, locale)} min`;
    }
    const hours = Math.floor(total / 60);
    const minutes = total % 60;
    const h = `${formatInt(hours, locale)} h`;
    return minutes === 0 ? h : `${h} ${String(minutes).padStart(2, "0")}`;
}
/**
 * `m:ss` from whole seconds: 90 → "1:30". Delegates to the rest timer's
 * `formatCountdown` so there is one countdown formatter in the package. The
 * floor keeps A2's `mmss` behaviour for a fractional input (`formatCountdown`
 * rounds milliseconds UP, which is right for a countdown and wrong here).
 */
export function formatClock(seconds) {
    return formatCountdown(Math.floor(Math.max(0, seconds)) * 1000);
}
//# sourceMappingURL=duration.js.map